module.exports = __webpack_public_path__ + "media/metronic/_theme/media/project-logos/2-018e5851ae9ee91231e9a85f85729b41.png";